import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    pageNumber: 1,
    fullName: "",
    pageSize: 100,
    companyId: "",
    leaderId: "",
    acceptedCandidate: "",
    campaignId: "",
    candidateStage: "",
    date: "YEARTODATE",
    aiFirst: "",
    candidateEmail: "",
    phoneNumber: "",
    isDownload: false,
}

const dealerCandidateReducer = createSlice({
  name: "weeklyFilters",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      return { ...state, ...action.payload }
    },
    clearFilters: () => initialState,
  },
})

export const { setFilters, clearFilters } = dealerCandidateReducer.actions

export default dealerCandidateReducer.reducer
